/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SaveNotificationAction } from './SaveNotificationAction';
import {
    SaveNotificationActionFromJSON,
    SaveNotificationActionFromJSONTyped,
    SaveNotificationActionToJSON,
} from './SaveNotificationAction';

/**
 * 
 * @export
 * @interface SaveNotification
 */
export interface SaveNotification {
    /**
     * 
     * @type {string}
     * @memberof SaveNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof SaveNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof SaveNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof SaveNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<SaveNotificationAction>}
     * @memberof SaveNotification
     */
    actions: Array<SaveNotificationAction>;
}

/**
 * Check if a given object implements the SaveNotification interface.
 */
export function instanceOfSaveNotification(value: object): value is SaveNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function SaveNotificationFromJSON(json: any): SaveNotification {
    return SaveNotificationFromJSONTyped(json, false);
}

export function SaveNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(SaveNotificationActionFromJSON)),
    };
}

export function SaveNotificationToJSON(value?: SaveNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(SaveNotificationActionToJSON)),
    };
}

